const $inject = ['$rootScope'];

const lbModalCtrl = function($rootScope) {
  let vm = this;

  vm.modalContent = null;
  vm.options = {};

  $rootScope.$on(
    'modals.open',
    function handleModalOpenEvent(event, modalContent, options) {
      vm.modalContent = modalContent;
      vm.options = options;
    }
  );

  $rootScope.$on(
    'modals.close',
    function handleModalCloseEvent() {
      vm.modalContent = null;
      vm.className = '';
    }
  );
};


lbModalCtrl.$inject = $inject;

export default lbModalCtrl;


// WEBPACK FOOTER //
// ./src/components/lbModal/lbModalCtrl.js